import React from "react";
import { Space } from "antd";
import { Button, CircularProgress } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DeleteIcon from "@mui/icons-material/Delete";
import ThumbDownAltIcon from "@mui/icons-material/ThumbDownAlt";

export default function DrawerActions({
  activeView,
  canClose,
  canDelete,
  enableRulesUpdate,
  hasData,
  loadingAction,
  onBack,
  onCloseRecord,
  onDelete,
  onMarkNotApplicable,
  onSaveRules
}) {
  if (activeView === "rules") {
    return (
      <Space wrap>
        {hasData && (
          <Button
            onClick={onSaveRules}
            variant="contained"
            startIcon={<CheckCircleIcon />}
            disabled={!enableRulesUpdate}
          >
            Gravar alterações
          </Button>
        )}
        <Button
          onClick={onBack}
          variant="contained"
          style={{ color: "#000", background: "#A6D9F7" }}
          startIcon={<ArrowBackIcon />}
        >
          Voltar
        </Button>
      </Space>
    );
  }

  if (!canDelete) return null;

  return (
    <Space wrap>
      {canClose && (
        <>
          <Button
            onClick={onCloseRecord}
            variant="contained"
            disabled={loadingAction !== null}
            style={{ color: "#fff", background: "#5BB25F" }}
            startIcon={loadingAction === "3" ? <CircularProgress size="20px" color="inherit" /> : <CheckCircleIcon />}
          >
            Fechar
          </Button>
          <Button
            onClick={onMarkNotApplicable}
            variant="contained"
            disabled={loadingAction !== null}
            style={{ color: "#fff", background: "#475657" }}
            startIcon={loadingAction === "2" ? <CircularProgress size="20px" color="inherit" /> : <ThumbDownAltIcon />}
          >
            Não aplicável
          </Button>
        </>
      )}
      <Button
        disabled={loadingAction !== null}
        variant="contained"
        style={{ color: "#fff", background: "#D05353" }}
        startIcon={loadingAction === "4" ? <CircularProgress size="20px" color="inherit" /> : <DeleteIcon />}
        onClick={onDelete}
      >
        Eliminar
      </Button>
    </Space>
  );
}
